// extracted by mini-css-extract-plugin
export default {"wrapper":"OrbitCanvas_wrapper__vYr1P","canvas":"OrbitCanvas_canvas__J6IRY","planet":"OrbitCanvas_planet__H4Vva"};